import React from 'react';
import {ActivityIndicator, Divider, List} from 'react-native-paper';
import {useQuery} from 'react-query';
import {Device} from '../../types';
import {View} from 'react-native';
import {getUserData} from '../../api';

export default function DevicesScreen(props: any) {
  const user = useQuery('UserData', () => getUserData(), {
    refetchOnWindowFocus: false,
  });
  const userLoading = user.isLoading;
  const userData = user.data;
  if (userLoading) return <ActivityIndicator size={72} />;
  return (
    <List.Section>
      {userData.devices.map((device: Device) => (
        <View key={device.id}>
          {device.id !== 'unknown' && device.manufacturer ? (
            <>
              <Divider />
              <List.Item
                key={device.id}
                left={props => (
                  <List.Icon
                    {...props}
                    icon={device.manufacturer.toLowerCase()}
                  />
                )}
                right={props => (
                  <List.Icon {...props} icon={'logout'} />
                )}
                description={`Created: ${new Date(
                  device.createdAt,
                ).toDateString()}`}
                title={`${device.model.replace(
                  new RegExp('-'),
                  ' ',
                )} on ${device.platform}`}
              />
              <Divider />
            </>
          ) : null}
        </View>
      ))}
    </List.Section>
  );
}
